<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Cambio de clave</b-card-header>
      <b-card-body>
        <div class="row form-group" v-if="ChangeLegendVisible">
          <div class="col-md-12">
            <span>Debe cambiar su password para seguir usando resimple</span>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <base-input
              placeholder="Clave Actual"
              class="input-group-alternative mb-3"
              v-model="model.ActualPassword"
              type="password"
              addon-left-icon="fa fa-fw fa-unlock-alt"
            ></base-input>
          </div>
        </div>

        <!-- <div class="row form-group">
          <div class="col-md-12">
            <base-input
              placeholder="Nueva clave"
              class="input-group-alternative mb-3"
              v-model="model.NewPassword"
              type="password"
            ></base-input>
          </div>
        </div>-->

        <password-validator
          v-model="model.NewPassword"
          @password-validated="updatePasswordValidity"
          placeholder="Nueva clave"
        ></password-validator>

        <div class="row form-group">
          <div class="col-md-12">
            <base-input
              placeholder="Repita nueva clave"
              class="input-group-alternative mb-3"
              v-model="model.RepeatNewPassword"
              type="password"
              addon-left-icon="fa fa-fw fa-unlock-alt"
            ></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12 text-center">
            <base-button
              type="success"
              size="lg"
              @click="cambiarPass"
              :disabled="model.passwordIsValid === false"
            >
              <i class="fa fa-fw fa-save"></i>Cambiar
            </base-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import { constants } from "crypto";
import PasswordValidator from "@/components/Custom/PasswordValidator";

export default {
  components: { PasswordValidator },
  data() {
    return {
      model: {
        ActualPassword: "",
        NewPassword: "",
        RepeatNewPassword: "",
        passwordIsValid: false
      },
      ChangeLegendVisible: false
    };
  },
  methods: {
    logout() {
      let context = this;

      axiosHelpers.axiosPost("Account/Logout", {}, this, function(data) {
        if (data.ResponseVM != null) {
          context.$store.dispatch("logout").then(() => {
            context.$router.push("login");
          });
        }
      });
    },
    updatePasswordValidity(isValid) {
      let context = this;
      context.model.passwordIsValid = isValid;
    },
    cambiarPass() {
      let context = this;
      if (
        this.model.ActualPassword == "" ||
        this.model.NewPassword == "" ||
        this.model.RepeatNewPassword == ""
      ) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "Complete todos los campos",
          this
        );
        return;
      } else if (this.model.NewPassword != this.model.RepeatNewPassword) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "Los campos clave y repetir clave deben ser iguales",
          this
        );
        return;
      }

      axiosHelpers.axiosPostWithOutSecurityValidations(
        "Account/ChangeInitialAccountPassword",
        {
          ActualPassword: this.model.ActualPassword,
          NewPassword: this.model.NewPassword
        },
        this,
        function(data) {
          if (data.ResponseVM.Resultado) {
            context.model = {
              ActualPassword: "",
              NewPassword: "",
              RepeatNewPassword: ""
            };
            context.$store.dispatch(
              "passwordChanged",
              !data.ResponseVM.Resultado
            );
            notificationHelpers.showSuccess(
              "Exito",
              "Se ha cambiado su clave correctamente",
              context
            );
            if (context.ChangeLegendVisible) {

              context.$router.push("dashboard");
            } else {
              axiosHelpers.axiosPost("Account/Logout", {}, context, function(
                data
              ) {
                if (data.ResponseVM != null) {
                  context.$store.dispatch("logout").then(() => {
                    context.$router.push("login");
                  });
                }
              });
            }
          }
        }
      );
    }
  },
  beforeMount: function() {
    let context = this;
    context.ChangeLegendVisible = context.$store.getters.userChangePassword;
  }
};
</script>